import Swal from "sweetalert2";
import axios from "axios";
import {
  format_date,
  format_time,
  truncate_description,
  get_event_media_files,
  get_event_resource_files
} from "./event_helper";

export const validate_ticket = (vm, scannedCode) => {
  if (!vm) return;
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/scan_event_ticket_qr_code/`,
    method: "POST",
    headers: {
      Authorization: `Token ${vm.get_auth_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      event_id: vm.current_event_id,
      unique_code: scannedCode,
    }),
    success: (response) => {
      vm.stop_camera_only();
      vm.scan_success = true;
      vm.scan_data = response;
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
    error: (xhr) => {
      vm.stop_camera_only();
      vm.scan_success = false;
      vm.scan_error_message = xhr.responseJSON?.message || "Invalid or used ticket.";
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
  });
};

export const validate_rsvp = (vm, scannedCode) => {
  if (!vm) return;
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/scan_event_rsvp_qr_code/`,
    method: "POST",
    headers: {
      Authorization: `Token ${vm.get_auth_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      event_id: vm.current_event_id,
      unique_code: scannedCode,
    }),
    success: (response) => {
      vm.stop_camera_only();
      vm.scan_success = true;
      vm.scan_data = response;
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
    error: (xhr) => {
      vm.stop_camera_only();
      vm.scan_success = false;
      vm.scan_error_message = xhr.responseJSON?.message || "Invalid or used ticket.";
      vm.show_camera = false;
      vm.scan_result_box = true;
    },
  });
};

export const submit_registration = (vm) => {
  if (!vm?.event) return;
  vm.selected_event = vm.event;
  if (vm.event.is_free) {
    vm.fetchEvents_extras(vm.event.id);
    return;
  }
  vm.process_to_checkout();
};

export const cancel_rsvp = (vm, event_id, user_id = null) => {
  if (!vm) return;
  const token = vm.get_auth_token();

  if (!Number.isInteger(event_id)) {
    Swal.fire({
      title: "Invalid ID",
      text: "The event ID is not valid.",
      icon: "error",
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
    });
    return;
  }
  const payload = { event_id };
  if (vm.user_details.user_role === "admin" && user_id) {
    payload.user_id = user_id;
  }
  payload.base_url = `${window.location.origin}${vm.$route.path}`;

  $.ajax({
    type: "POST",
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_rsvp/`,
    contentType: "application/json",
    data: JSON.stringify(payload),
    headers: {
      Authorization: `Token ${token}`,
    },
    success: (data) => {
      if (data.status === "success") {
        if (vm.event?.id === event_id && (!user_id || vm.user_details.user_id === user_id)) {
          vm.event.is_rsvped = false;
        }
        Swal.fire({
          icon: "success",
          title: "RSVP Cancelled",
          showConfirmButton: false,
          timer: 2000,
          position: 'bottom-end',
          toast: true
        }).then(() => {
          $("#exampleModal").modal("hide");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: data.message || "Cancel failed",
          icon: "error",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
      }
    },
    error: (xhr) => {
      const response = xhr.responseJSON || {};
      Swal.fire({
        title: "Error",
        text: response.message || "Something went wrong",
        icon: "error",
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    },
  });
};

export const view_ticket_attendees = (vm, event) => {
  const event_id = event?.id;
  if (!vm || !event_id) return;
  vm.is_submitting = true;
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_ticket_instances/`,
    method: "POST",
    headers: {
      Authorization: `Token ${vm.get_auth_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify({ event_id }),
    success: (data) => {
      vm.event_ticket_attendees = data.instances || [];
      $("#event_user_ticket").modal("show");
    },
    complete: () => {
      vm.is_submitting = false;
    },
  });
};

export const open_media_gallery = (vm, event) => {
  if (!vm) return;
  vm.event_id = event?.id ?? vm.event_id;
  vm.$refs.eventMediaGalleryRef?.open_media_gallery_modal?.(event);
};

export const open_document_upload = (vm, event) => {
  if (!vm) return;
  vm.event_id = event?.id ?? vm.event_id;
  vm.$refs.eventResourceRef?.open_document_modal?.(event);
};

export const get_icon_class = (vm, item) => {
  if (!vm) return undefined;
  return vm.$refs.eventResourceRef?.get_icon_class(item);
};

export const get_file_type_label = (vm, item) => {
  if (!vm) return undefined;
  return vm.$refs.eventResourceRef?.get_file_type_label(item);
};

export const get_file_name = (vm, item) => {
  if (!vm) return undefined;
  return vm.$refs.eventResourceRef?.get_file_name(item);
};

export const open_preview = (vm, item) => {
  if (!vm) return;
  vm.$refs.eventResourceRef?.open_preview(item);
};

export const download_document = (vm, item) => {
  if (!vm) return;
  vm.$refs.eventResourceRef?.download_document(item);
};

export const update_parent_event_files = (vm, newFiles) => {
  if (!vm?.event) return;
  if (!Array.isArray(vm.event.event_files)) {
    vm.event.event_files = [];
  }
  vm.event.event_files.unshift(...newFiles);
};

export const handle_parent_file_deletion = (vm, deletedFileId) => {
  if (!vm?.event?.event_files) return;
  vm.event.event_files = vm.event.event_files.filter((file) => file.id !== deletedFileId);
};

export const handle_pin_update = (vm, payload) => {
  if (!vm?.event?.event_files) return;
  const index = vm.event.event_files.findIndex((file) => file.id === payload.id);
  if (index === -1) return;
  vm.event.event_files.at(index).is_pinned = payload.is_pinned;
};

export const fetch_event = (vm) => {
  if (!vm) return;
  const event_id = vm.$route.params.event_id;
  if (!event_id) {
    vm.error_message = "Missing event id.";
    vm.is_loading = false;
    return;
  }
  vm.is_loading = true;
  vm.error_message = "";
  const user_id = vm.get_user_id();
  const token = vm.get_auth_token();
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event/`,
    contentType: "application/json",
    method: "POST",
    headers: token
      ? {
        Authorization: `Token ${token}`,
      }
      : {},
    data: JSON.stringify({ event_id: Number(event_id), user_id }),
    success: (response) => {
      if (response?.status === "success") {
        vm.event = response.event;
        vm.event_id = response?.event?.id ?? Number(event_id);
        vm.selected_event = response.event;
        const tickets = Array.isArray(response?.event?.event_tickets)
          ? response.event.event_tickets
          : [];
        vm.event_tickets = tickets.map((ticket) => ({
          ...ticket,
          quantitySelected: 0
        }));
      } else {
        vm.error_message = response?.message || "Failed to load event.";
      }
    },
    error: (xhr) => {
      vm.error_message = xhr?.responseJSON?.message || "Failed to load event.";
    },
    complete: () => {
      vm.is_loading = false;
    }
  });
};

export const view_attendees = (vm) => {
  if (!vm?.event?.id) return;
  if (vm.event.is_free) {
    $("#exampleModal").modal("show");
    return;
  }
  vm.view_ticket_attendees(vm.event);
};

export const total_registrations = (event) => {
  const e = event || {};
  const rsvpCurrent = e.rsvp_list?.filter(rsvp => rsvp.rsvp_status?.name === "confirmed").length || 0;
  return rsvpCurrent + Number(e.ticket_purchase_count || 0);
};

export const capacity_value = (event) => {
  const rsvpCapacity = Number(event?.rsvp_cap?.rsvp_max_capacity ?? 0);
  if (rsvpCapacity > 0) return rsvpCapacity;

  const ticketCapacity = Array.isArray(event?.event_tickets)
    ? event.event_tickets.reduce((sum, t) => sum + Number(t.quantity ?? 0), 0)
    : 0;

  if (ticketCapacity > 0) return ticketCapacity;
  return 0;
};

export const capacity_percent = (total, capacity) => {
  if (!capacity) return 0;
  const percent = (total / capacity) * 100;
  return Math.max(0, Math.min(100, Math.round(percent)));
};

export const capacity_text = (total, capacity) => {
  if (!capacity) return "Capacity Maximum";
  return `${total} of ${capacity} capacity`;
};

export const event_date_line = (event) => {
  if (!event) return "";
  const startDate = format_date(event.start_date);
  const endDate = format_date(event.end_date);
  const startTime = format_time(event.start_time);
  const endTime = format_time(event.end_time);
  if (startDate === endDate) {
    return `${startDate} \u00b7 ${startTime || ""}${startTime && endTime ? " - " : ""}${endTime || ""}`.trim();
  }
  return `${startDate} ${startTime || ""} - ${endDate} ${endTime || ""}`.trim();
};

export const ticket_breakdown = (event) => {
  const items = [];
  if (event?.is_free) {
    items.push({
      label: "Free RSVPs",
      value: Number(event?.rsvp_count ?? event?.rsvp_list?.filter(rsvp => rsvp.rsvp_status?.name === "Confirmed").length ?? 0),
      sublabel: "confirmed"
    });
  }
  if (Array.isArray(event?.event_tickets)) {
    event.event_tickets.slice(0, 3).forEach((ticket) => {
      items.push({
        label: ticket?.ticket?.name || "Ticket",
        value: Number(ticket?.quantity ?? 0),
        sublabel: "available"
      });
    });
  }
  return items;
};

export const can_edit = (token_exists, event, user_details, user_id) => {
  if (!token_exists || !event) return false;
  return user_details?.user_role === "admin" || String(event?.user?.id) === String(user_id);
};

export const show_ticket_rsvp_card = (token_exists, event, user_details, user_id) => {
  if (!event) return false;
  return user_details?.user_role !== "admin" || String(event?.user?.id) !== String(user_id);
};

export const is_event_attendee = (token_exists,event,user_details,user_id,event_ticket_attendees = []) => {
  const userId = String(user_id || "");

  const accessChecks = [
    !token_exists,
    !event,
    !user_id
  ];

  if (accessChecks.some(Boolean)) return false;

  if ([user_details?.user_role === "admin", String(event?.user?.id) === userId].some(Boolean)) return true;

  if ([event?.is_waitlisted, event?.is_rsvped].includes(true)) {
    return !event?.is_waitlisted;
  }

  const lists = [event?.rsvp_list, event_ticket_attendees];

  return lists.some(
    (list) =>
      Array.isArray(list) &&
      list.some((entry) =>
        !["cancelled", "waitlisted"].includes(
          String(entry?.rsvp_status?.name || "").toLowerCase()
        ) &&
        [entry?.user?.id, entry?.user_id].map((id) => String(id || "")).includes(userId)
      )
  );
};
const can_view_event_content = (is_public, token_exists, event, user_details, user_id, event_ticket_attendees = []) => {
  if (!event) return false;
  if (is_public !== false) return true;
  return is_event_attendee(token_exists, event, user_details, user_id, event_ticket_attendees);
};

export const can_view_gallery = (token_exists, event, user_details, user_id, event_ticket_attendees = []) => {
  return can_view_event_content(event?.public_gallery, token_exists, event, user_details, user_id, event_ticket_attendees);
};

export const can_view_materials = (token_exists, event, user_details, user_id, event_ticket_attendees = []) => {
  return can_view_event_content(event?.public_slides, token_exists, event, user_details, user_id, event_ticket_attendees);
};

export const gallery_preview = (event, canViewGallery = true) => {
  if (!event || !canViewGallery) return [];
  return get_event_media_files(event).slice(0, 4);
};

export const has_more_gallery = (event, canViewGallery = true) => {
  if (!event || !canViewGallery) return false;
  return get_event_media_files(event).length > 4;
};

export const materials_list = (event, canViewMaterials = true) => {
  if (!event || !canViewMaterials) return [];
  return get_event_resource_files(event);
};

export const materials_preview = (list) => {
  return list.slice(0, 4);
};

export const has_more_materials = (list) => {
  return list.length > 4;
};

export const materials_count = (list) => {
  return list.length;
};

export const description_text_length = (event) => {
  if (!event?.description) return 0;
  const plainText = event.description.replace(/<[^>]*>/g, "").trim();
  return plainText.length;
};

export const has_long_description = (event) => {
  if (!event?.description) return false;
  const plainText = event.description.replace(/<[^>]*>/g, "").trim();
  const wordCount = plainText.split(/\s+/).filter(Boolean).length;
  return wordCount > 100;
};

export const plain_description = (event) => {
  if (!event?.description) return "";
  return event.description.replace(/<[^>]*>/g, "").trim();
};

export const truncated_description = (plainText) => {
  return truncate_description(plainText, 100);
};

export const map_embed_url = (event) => {
  if (event?.event_type?.name === "online") return "";
  const location = (event?.location || "").trim();
  if (!location) return "";
  return `https://www.google.com/maps?q=${encodeURIComponent(location)}&z=15&output=embed`;
};

export const selected_ticket = (eventTickets, selectedTicketId) => {
  if (!selectedTicketId) return null;
  return eventTickets.find((ticket) => String(ticket.id) === String(selectedTicketId)) || null;
};

export const selected_tickets_total = (eventTickets) => {
  return eventTickets.reduce((sum, ticket) => {
    const qty = Number(ticket?.quantitySelected || 0);
    const price = Number(ticket?.price || 0);
    return sum + qty * price;
  }, 0);
};

export const add_rsvp = async (vm) => {
  if (!vm) return;

  // 🔐 Not logged in
  if (!vm.token_exists) {
    const nextUrl = vm.$router?.currentRoute?.value?.fullPath;

    if (nextUrl) {
      sessionStorage.setItem("next", nextUrl);
      sessionStorage.setItem("selected_event", JSON.stringify(vm.selected_event));
      sessionStorage.setItem("selected_item_id", JSON.stringify(vm.selected_item_id));
      sessionStorage.setItem("business_name", JSON.stringify(vm.business_name));
      sessionStorage.setItem("is_first_time", JSON.stringify(vm.is_first_time));
      sessionStorage.setItem("chapter", JSON.stringify(vm.chapter));
    }

    vm.$router.push("/sign_in_Finale");
    return;
  }

  vm.is_submitting = true;

  try {
    const formData = buildFormData(vm);
    const config = {
      headers: { Authorization: `Token ${vm.get_auth_token()}` }
    };
    const { data } = await axios.post(
      `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_rsvp/`,
      formData,
      config
    );

    handleResponse(vm, data, true);
  } catch (error) {
    const message =
      error?.response?.data?.message || "RSVP failed.";
    handleResponse(vm, message, false);
  } finally {
    vm.is_submitting = false;
  }
};

const buildFormData = (vm) => {
  const formData = new FormData();

  formData.append("event_id", vm.selected_event.id);

  const items = Array.isArray(vm.selected_item_id)
    ? vm.selected_item_id
    : [vm.selected_item_id];

  items.forEach((id) => formData.append("item_id", id));

  formData.append("business_name", vm.business_name || "");
  formData.append("is_first_time", vm.is_first_time ? "True" : "False");
  formData.append("chapter", vm.chapter || "");

  return formData;
};

const handleResponse = (vm, payload, isSuccess) => {
  let message = "RSVP failed.";

  if (isSuccess && payload?.status === "success") {
    const isWaitlisted =
      payload?.rsvp_data?.rsvp_status?.name === "waitlisted";

    if (isWaitlisted) {
      vm.event.is_waitlisted = true;
    } else {
      vm.event.is_rsvped = true;
    }

    message = "RSVP Successful";
  } else if (!isSuccess) {
    message = payload;
  }

  Swal.fire({
    icon: isSuccess ? "success" : "info",
    title: isSuccess ? message : undefined,
    text: !isSuccess ? message : undefined,
    showConfirmButton: false,
    timer: 2000,
    position: 'bottom-end',
    toast: true
  }).then(() => {
    Swal.close();

    [
      "selected_event",
      "selected_item_id",
      "business_name",
      "is_first_time",
      "chapter",
    ].forEach((key) => sessionStorage.removeItem(key));

    vm.selected_event = {};
    vm.selected_item_id = [];
    vm.business_name = "";

    $("#rsvp_modal").modal("hide");
  });
};
